import React from 'react'
import { SidebarAccessIcon } from './icons/SidebarAccessIcon'
import { SidebarForumIcon } from './icons/SidebarForumIcon'
import { SidebarGuideIcon } from './icons/SidebarGuideIcon'
import { SidebarHomeIcon } from './icons/SidebarHomeIcon'
import { SidebarLiveIcon } from './icons/SidebarLiveIcon'
import { SidebarRiskIcon } from './icons/SidebarRiskIcon'
import { SidebarPropertyIcon } from './icons/SidebarPropertyIcon'

interface SidebarIconWrapperProps {
  iconName: string
  active: boolean
  size?: number
}

type SidebarIconComponentProps = {
  active?: boolean
  size?: number
  className?: string
}

const iconMap: Record<string, React.ComponentType<SidebarIconComponentProps>> = {
  HomeIcon: SidebarHomeIcon as React.ComponentType<SidebarIconComponentProps>,
  RiskIcon: SidebarRiskIcon as React.ComponentType<SidebarIconComponentProps>,
  AccessIcon: SidebarAccessIcon as React.ComponentType<SidebarIconComponentProps>,
  RexLiveIcon: SidebarLiveIcon as React.ComponentType<SidebarIconComponentProps>,
  ForumIcon: SidebarForumIcon as React.ComponentType<SidebarIconComponentProps>,
  GuideIcon: SidebarGuideIcon as React.ComponentType<SidebarIconComponentProps>,
  PropertyIcon: SidebarPropertyIcon as React.ComponentType<SidebarIconComponentProps>,
}

export const SidebarIconWrapper = ({ iconName, active, size = 20 }: SidebarIconWrapperProps) => {
  const Icon =
    iconMap[iconName] ?? (SidebarGuideIcon as React.ComponentType<SidebarIconComponentProps>)

  return <Icon size={size} active={active} className="text-sidebar-foreground" />
}
